/* eslint-disable no-unused-vars, no-console, no-undef */

export default () => {

  // * GENERAL SITE ACCESSIBILITY * ///

  // CHAT IFRAME (SITE FOOTER)

  if ($('#comm100-iframe').length) {
    const $chatBox = $('#comm100-iframe');

    // set title attr
    $chatBox.attr('title', 'ASCE contact us chat');
  }

  // * ACCESSIBILITY FOR COVEO * //

  if ($('.coveo-wrapper').length || $('.asce-coveo-search').length) {
    const listboxInit = () => {
      // set listbox and options aria attributes

      const $listbox = $('.coveo-magicbox-suggestions[role="listbox"]'),
            $options = $('.coveo-magicbox-suggestions[role="listbox"] div[role="option"]'),
            $coveoFilters = $('.coveo-dropdown-header-wrapper');

      if ($listbox.length) {
        // set listbox aria attr
        $listbox.attr('aria-labelledby', 'search-suggestion-list');

        // inject label above the listbox

        $listbox.each((i, item) => {

          const $item = $(item);

          if ($item.prev().hasClass('search-suggestion-list-label')) {
            return;
          }

          $(`<label class="sr-text search-suggestion-list-label" id="search-suggestion-list" for=${item.getAttribute('id')}>Suggestion List</label>`).insertBefore(item);
        });
      }

      if ($options.length) {

        // set options aria attr
        $options.attr('aria-selected', 'false');

        $options.click((e) => {

          // reset options aria-selected to false state
          $options.attr('aria-selected', 'false');

          // update the currently selected option to true
          const $this = $(e.currentTarget);
          const optionState = $this.attr('aria-selected');

          if (optionState === 'false') {
            $this.attr('aria-selected', true);
          } else {
            $this.attr('aria-selected', false);
          }
        });
      }

      // hide coveo mobile filters

      if ($coveoFilters.length) {
        $coveoFilters.css('display', 'none');
      }
    };

    listboxInit();

    if (Coveo !== undefined) {
      Coveo.SearchEndpoint.configureSampleEndpointV2();
      let root = $('.asce-coveo-search'),
          root2 = $('.asce-coveo-search'),
          root3 = $('.asce-coveo-search'),
          root4 = $('.asce-coveo-search'),
          root5 = $('.asce-coveo-search'),
          root6 = $('.asce-coveo-search'),
          root7 = $('.asce-coveo-search');

      const resultImages = $('.CoveoResultList topics-news-list-item-image-wrapper img');

      if (resultImages.length) {
        resultImages.attr('alt', 'ASCE Listing Result');
      }

      if ($('#AsceMainSiteHeaderGlobalSearchBox').length) {
        root = document.querySelector('#AsceMainSiteHeaderGlobalSearchBox');
      }

      if ($('#AsceMainSiteHeaderGlobalSearchBox_container').length) {
        root2 = document.querySelector('#AsceMainSiteHeaderGlobalSearchBox_container');
      }

      if ($('#AsceMainSiteCoveoSearchInterface').length) {
        root3 = document.querySelector('#AsceMainSiteCoveoSearchInterface');
      }

      if ($('#AsceMainSiteHomeHeroGlobalSearchbox').length) {
        root4 = document.querySelector('#AsceMainSiteHomeHeroGlobalSearchbox');
      }

      if ($('#AsceMainSiteHomeHeroGlobalSearchbox_container').length) {
        root5 = document.querySelector('#AsceMainSiteHomeHeroGlobalSearchbox_container');
      }

      if ($('#AsceSectionGlobalSearchBox').length) {
        root6 = document.querySelector('#AsceSectionGlobalSearchBox');
      }

      if ($('#AsceSectionGlobalSearchBox_container').length) {
        root7 = document.querySelector('#AsceSectionGlobalSearchBox_container');
      }

      if (root !== null) {
        Coveo.$$(root).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root);
        });
      }

      if (root2 !== null) {
        Coveo.$$(root2).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root2);
        });
      }

      if (root3 !== null) {
        Coveo.$$(root3).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root3);
        });
      }

      if (root4 !== null) {
        Coveo.$$(root4).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root4);
        });
      }

      if (root5 !== null) {
        Coveo.$$(root5).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root5);
        });
      }

      if (root6 !== null) {
        Coveo.$$(root6).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root6);
        });
      }

      if (root7 !== null) {
        Coveo.$$(root7).on('afterInitialization', function() {
          listboxInit();
          Coveo.init(root7);
        });
      }
    }

    if ($('.bluberry-embed').length) {
      const $podcast = $('.bluberry-embed iframe');

      // set title attr
      $podcast.attr('title', 'ASCE podcast player');
    }
  }
};
